(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.common.component.video-facebook'
  const templateUrl = require('./tpl/video-facebook.html')

  require('./scss/video-facebook.scss')

  angular
    .module(MODULE_NAME, [
      require('../../../cms/common/provider/oauth/facebook')
    ])
    .component('thismomentVideoFacebook', {
      bindings: {
        videoUrl: '<',
        trackEvent: '&'
      },
      templateUrl: templateUrl,
      controller: videoFbController
    })

  videoFbController.$inject = ['$rootScope', 'Facebook', '$element']
  function videoFbController ($rootScope, Facebook, $element) {
    var vm = this

    vm.$onInit = function () {
      vm.kioskMode = $rootScope.kioskMode
      Facebook.parseXFBML($element)
      if (vm.trackEvent) {
        Facebook.subscribe('xfbml.ready', function (msg) {
          const videoplayer = msg.instance
          videoplayer.subscribe('startedPlaying', function (e) {
            vm.trackEvent({
              action: 'Content Converted',
              properties: {
                'event trigger': 'Video Started'
              }
            })
          })
          videoplayer.subscribe('paused', function (e) {
            vm.trackEvent({
              action: 'Content Converted',
              properties: {
                'event trigger': 'Video Paused'
              }
            })
          })
          videoplayer.subscribe('finishedPlaying', function (e) {
            $rootScope.$emit('videoCompleted')
            vm.trackEvent({
              action: 'Content Converted',
              properties: {
                'event trigger': 'Video Completed'
              }
            })
          })
        })
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/component/video-facebook/index.js